import React, { useEffect, useState } from "react";
import axios from "axios";
import useEmirateFromCoordinates, { BACKEND_URL, ImageURL, fastApiCall, fastApiClient } from "../common/Common.js";
import { Link, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import "../unlimitedoffers/UnlimitedOffers.css"

//Navbar and Left Section Images
import hayatin from '../../assets/images/hayatin.jpg';
import homeicon from '../../assets/home-images/homeicon.jpg';
import experienceicon from '../../assets/home-images/experienceicon.jpg';
import businessicon from '../../assets/home-images/businessicon.jpg';
import plusicon from '../../assets/home-images/plusicon.png';
import profileicon from '../../assets/home-images/profileicon.png';
import search from '../../assets/home-images/search.png';
import videos from '../../assets/home-images/videos.png';
import blogs from '../../assets/home-images/blogs.png';
import save from '../../assets/home-images/save.png';
import menu from '../../assets/home-images/menu.png';
import downarrow from '../../assets/home-images/downarrow.png';
import flagicon from '../../assets/home-images/flagicon.png';
import expbanner from '../../assets/experience/Expbanner.png';
import xmark from '../../assets/home-images/right-section-images/xmark.png';
import mobiletoggle from '../../assets/home-images/mobiletoggle.png';
import app_store from '../../assets/home-images/right-section-images/app_store.png';
import play_store from '../../assets/home-images/right-section-images/play_store.png';

import rightarrow from '../../assets/home-images/right-section-images/rightarrow.png';
import downarrowicon from '../../assets/categorylist/downarrowicon.png';
import filtericon from '../../assets/categorylist/filtericon.png';
import mapicon from '../../assets/categorylist/mapicon.png';
import menuicon from '../../assets/categorylist/menuicon.png';
import vertical_line from '../../assets/categorylist/vertical_line.png';
import leftarrow from '../../assets/offers/leftarrow.png';


import omanflag from '../../assets/experience/omanflag.png';
import qatarflag from '../../assets/experience/qatarflag.png';
import kuwaitflag from '../../assets/experience/kuwaitflag.png';
import ksaflag from '../../assets/experience/ksaflag.png';
import nodata from '../../assets/experience/nodata.png';
import Navbar from "../common-component/navbar/Navbar.js";


const countryicons = [omanflag, qatarflag, kuwaitflag, ksaflag]
const tabMapping = {
    'UnlimitedOffers': 'UnlimitedOffers',
    'TrendingThisWeek': 'Trending This Week',
    'LimitedTimeDeals': 'Limited-Time Deals'
};


const UnlimitedOffers = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [countrypopup, setCountrypopup] = useState(false);
    const [states, setStates] = useState([]); // countrylist get api state
    const [selectedState, setSelectedState] = useState(null);
    const [filterpopup, setFilterpopup] = useState(false);
    // Set default coordinates immediately for faster initial load
    const [latitude, setLatitude] = useState(24.4539);
    const [longitude, setLongitude] = useState(54.3773);
    const [offers, setOffers] = useState([]); // offer page list get api state
    const [categorylist, setCategorylist] = useState([]); // categorylist Post api state 
    const [offertype, setOffertype] = useState([]);
    const [openoffertype, setOpenoffertype] = useState(false);
    const [selectedOfferTypes, setSelectedOfferTypes] = useState([]);
    const [categories, setCategories] = useState([]);
    const [showcatgoryname, setShowcategoryname] = useState(false);
    const [filteredCoupons, setFilteredCoupons] = useState({});
    const emirate = useEmirateFromCoordinates(latitude, longitude);
    const [loading, setLoading] = useState(true);
    const [filteredData, setFilteredData] = useState([]);
    const [menuOpen, setMenuOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const tabFromUrl = searchParams.get('tab') || 'UnlimitedOffers';

    // Scroll to top on mount (fixes mobile scroll position issue)
    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
    }, []);

    // Initialize activeTab from URL parameter on initial load
    const initialTab = tabMapping[tabFromUrl] || 'UnlimitedOffers';
    const [activeTab, setActiveTab] = useState(initialTab);

    const closeMenu = () => {
        setMenuOpen(false);
    };

    // Prevent body scroll when sidebar is open
    useEffect(() => {
        if (menuOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }

        // Cleanup on unmount
        return () => {
            document.body.style.overflow = '';
        };
    }, [menuOpen]);

    useEffect(() => {
        const tabName = tabMapping[tabFromUrl];
        if (tabName) {
            setActiveTab(tabName);
        }
    }, [tabFromUrl]);
    const toggleOfffertype = () => {
        setOpenoffertype(!openoffertype)
    }

    const togglecategoryname = () => {
        setShowcategoryname(!showcatgoryname);
    };

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
    };

    const clearSearch = () => {
        setSearchTerm("");
    };

    const handleCheckboxChange = (e, id) => {
        if (e.target.checked) {
            setSelectedOfferTypes([...selectedOfferTypes, id]);
        } else {
            setSelectedOfferTypes(selectedOfferTypes.filter((item) => item !== id));
        }
    };

    const matchedOfferTypes = offertype.discounttypeData
        ?.filter((off) =>
            categorylist.some((item) => item.discount_type_id == off.id)
        )
        .map(off => ({ ...off, id: Number(off.id) }))
        .filter(
            (value, index, self) =>
                index === self.findIndex((t) => t.id === value.id)
        );

    const clearAllFilters = () => {
        setSelectedOfferTypes([]);
        setFilteredCoupons({});
    };

    // Build categoriesPerCoupon - this needs to include ALL coupons from ALL tabs
    const getAllCoupons = () => {
        let allCoupons = [...categorylist];

        offers.forEach(offer => {
            if (offer.offer_items && Array.isArray(offer.offer_items)) {
                allCoupons = [...allCoupons, ...offer.offer_items];
            }
        });

        return allCoupons;
    };

    const categoriesPerCoupon = getAllCoupons().map(coupon => ({
        coupon_id: coupon.coupon_id,
        categories: coupon.category?.map(cat => ({
            id: cat.category,
            name: cat.category_name
        })) || []
    }));

    // Get data for Trending This Week - find by title match
    const getTrendingData = () => {
        const trendingOffers = offers.filter(o =>
            o.title === "Trending This Week" ||
            o.title?.toLowerCase().includes("trending")
        );
        return trendingOffers.flatMap(o => o.offer_items || []);
    };

    // Get data for Limited Time offer - find by title match
    const getLimitedTimeData = () => {
        const limitedOffers = offers.filter(o =>
            o.title === "Limited-Time Deals" ||
            o.title === "Limited Time offer" ||
            o.title?.toLowerCase().includes("limited")
        );
        return limitedOffers.flatMap(o => o.offer_items || []);
    };

    // Apply filters to all tabs
    const handleShowResult = () => {
        // If no filters selected, clear all filters
        if (selectedOfferTypes.length === 0) {
            setFilteredCoupons({});
            setFilterpopup(false);
            return;
        }

        const newFilteredCoupons = {};

        // Filter function
        const applyFilters = (coupons) => {
            return coupons.filter(coupon => {
                const couponCategories = categoriesPerCoupon.find(c => c.coupon_id === coupon.coupon_id)?.categories || [];

                // Check if coupon matches category filter OR discount type filter
                const categoryMatch = couponCategories.some(cat => selectedOfferTypes.includes(cat.id));
                const discountTypeMatch = selectedOfferTypes.includes(coupon.discount_type_id);

                return categoryMatch || discountTypeMatch;
            });
        };

        // Apply filters to UnlimitedOffers tab
        newFilteredCoupons["UnlimitedOffers"] = applyFilters(categorylist);

        // Apply filters to Trending This Week tab
        const trendingData = getTrendingData();
        if (trendingData.length > 0) {
            const trendingOffer = offers.find(o => o.title?.toLowerCase().includes("trending"));
            if (trendingOffer) {
                newFilteredCoupons[trendingOffer.title] = applyFilters(trendingData);
            }
        }

        // Apply filters to Limited Time offer tab
        const limitedData = getLimitedTimeData();
        if (limitedData.length > 0) {
            const limitedOffer = offers.find(o => o.title?.toLowerCase().includes("limited"));
            if (limitedOffer) {
                newFilteredCoupons[limitedOffer.title] = applyFilters(limitedData);
            }
        }

        // Apply filters to all view_type 3 tabs
        offers
            .filter(o => o.view_type === 3)
            .forEach(offer => {
                newFilteredCoupons[offer.title] = applyFilters(offer.offer_items || []);
            });

        // Apply filters to all view_type 5 tabs
        offers
            .filter(o => o.view_type === 5)
            .forEach(offer => {
                newFilteredCoupons[offer.title] = applyFilters(offer.offer_items || []);
            });

        setFilteredCoupons(newFilteredCoupons);
        setFilterpopup(false);
    };

    // Get display data for any tab
    const getDisplayData = (tabName, defaultData) => {
        // If there's a search term, only show results in UnlimitedOffers tab
        // Other tabs should show empty array (which will display "no data" message)
        if (searchTerm.trim() !== "") {
            if (tabName === "UnlimitedOffers") {
                return defaultData;
            } else {
                return []; // Return empty array for other tabs when searching
            }
        }

        // Only apply filters if "Show Result" button was clicked
        // Check if filteredCoupons has any data at all (meaning Show Result was clicked)
        if (Object.keys(filteredCoupons).length === 0) {
            return defaultData;
        }

        // If Show Result was clicked, return filtered data (even if empty array)
        return filteredCoupons[tabName] !== undefined ? filteredCoupons[tabName] : [];
    };


    //SHIMMER LOADER
    const ShimmerLoader = () => {
        return (
            <div className="offers-grid-container">
                {[...Array(6)].map((_, index) => (
                    <div key={index} className="offer-card-grid shimmer-card">
                        <div className="offer-img-wrapper shimmer-img"></div>
                        <div className="offer-details">
                            <div className="shimmer-line shimmer-location"></div>
                            <div className="shimmer-line shimmer-title"></div>
                            <div className="shimmer-line shimmer-distance"></div>
                            <div className="shimmer-line shimmer-price"></div>
                        </div>
                    </div>
                ))}
            </div>
        );
    };

    // Helper function to render offer cards (DRY principle)
    const renderOfferCard = (item, index) => {
        const categoryId = item.category?.[0]?.category || item.category_id || 0;
        let discountText = <span className="offer-tag">{item.discount_type}</span>;

        switch (item.discount_type_id) {
            case 8:
            case 4:
                discountText = <span className="offer-tag">{item.discount_type}</span>;
                break;
            case 7:
                discountText = <span className="offer-tag">{item.discount_value ? `${item.discount_value}% OFF` : item.discount_type}</span>;
                break;
            case 5:
                discountText = <span className="offer-tag">Up to {item.discount_value ? `${item.discount_value}% OFF` : ""}</span>;
                break;
            case 1:
                discountText =
                    item.discount_value && item.discount_price && item.coupon_price ? (
                        <>
                            <span className="old-price">AED {item.coupon_price}</span>
                            <span className="new-price">AED {item.discount_price}</span>
                            <span className="separator">|</span>
                            <span className="discount">{item.discount_value}% OFF</span>
                        </>
                    ) : (
                        <span className="offer-tag">AED {item.coupon_price}</span>
                    );
                break;
            case 10:
                discountText = <span className="discount_type_from">From <span className="discount_coupon_price">AED {item.coupon_price}</span></span>;
                break;
            default:
                discountText = item.discount_type === "Total" ? <span className="offer-tag">{item.discount_value}% OFF</span> : <span className="offer-tag">{item.discount_type}</span>;
        }

        return (
            <Link to={`/offers/${item.coupon_id}/${categoryId}`} key={index} className="remove-underline">
                <div className="offer-card-grid">
                    <div className="offer-img-wrapper">
                        <img src={item.coupon_image} alt={item.coupon_title || "Offer"} />
                    </div>
                    <div className="offer-details">
                        <p className="offer-location">
                            <span><img src={businessicon} alt="logo" className="bussinessicon" /></span>
                            <span>{item.user_name || item.vendor_name || "Vendor"}</span>
                        </p>
                        <h4>{item.coupon_title || "Title"}</h4>
                        <div className="kilometer-location">
                            <p className="offer-distance">{item.distance ? item.distance.toFixed(1) : "0.0"} km</p>
                            <span>|</span>
                            <p className="offer-location">{item.location || "-"}</p>
                        </div>
                        <div className="offer-prices">{discountText}</div>
                    </div>
                </div>
            </Link>
        );
    };



    const fetchMasterData = async () => {
        try {
            await fastApiCall(
                () => fastApiClient.get(`${BACKEND_URL}website/get-master-data`),
                null, // No separate loading state for this individual call
                (data) => {
                    const stateData = data?.stateData || [];
                    setStates(stateData);
                }
            );
        } catch (error) {
            console.error("Error fetching master data:", error);
            setStates([]);
        }
    };

    // FETCH THE OFFERS DATA AND DISPLAY TRENDING THIS WEEK AND LIMITED DEALS WITH THEIR VIEW_TYPE
    const fetchOffers = async () => {
        const params = {
            latitude: latitude || 24.4539,
            longitude: longitude || 54.3773,
            state_id: selectedState?.id || emirate?.id || "",
            user_id: "",
        };

        try {
            await fastApiCall(
                () => fastApiClient.post(`${BACKEND_URL}website/getofferspagelist`, params),
                null, // No separate loading state for this individual call
                (data) => {
                    setOffers(data);
                }
            );
        } catch (error) {
            console.error("Error fetching offers:", error);
            setOffers([]);
        }
    };

    // FETCH UNLIMITED OFFERS DATA AND DISPLAY IT WHEN UNLIMITED OFFERS TAB IS ACTIVE
    const fetchCouponList = async (search = "") => {
        try {
            await fastApiCall(
                () => fastApiClient.post(`${BACKEND_URL}website/get-coupon-list`, {
                    state_id: selectedState?.id || emirate?.id || 1,
                    latitude: latitude || 24.4539,
                    longitude: longitude || 54.3773,
                    search: search || "",
                }),
                setLoading, // This manages the main loading state
                (data) => {
                    const extractedData = data?.data || data || [];
                    setCategorylist(extractedData);
                },
                (responseData) => responseData?.data || responseData
            );
        } catch (error) {
            console.error("Error fetching categories lists:", error);
            setCategorylist([]);
            setLoading(false); // Hide loading on error
        }
    };

    // FETCH OFFER TYPES AND DISPLAY IN THE SIDE DRAWER FILTER
    const fetchOffertype = async () => {
        try {
            await fastApiCall(
                () => fastApiClient.get(`${BACKEND_URL}website/get-common-data`),
                null, // No separate loading state for this individual call
                (data) => {
                    setOffertype(data);
                }
            );
        } catch (error) {
            console.error("Error fetching offer types:", error);
            setOffertype([]);
        }
    };


    // FETCH CATEGORY NAMES AND DISPLAY IN THE SIDE DRAWER FILTER
    const fetchCategories = async () => {
        try {
            await fastApiCall(
                () => fastApiClient.get(`${BACKEND_URL}website/categories`),
                null, // No separate loading state for this individual call
                (data) => {
                    const categoriesData = data?.data || data || [];
                    setCategories(categoriesData);
                },
                (responseData) => responseData?.data || responseData
            );
        } catch (error) {
            console.error("Error fetching categories:", error);
            setCategories([]);
        }
    };


    // Load selected state from localStorage on mount
    useEffect(() => {
        const savedState = localStorage.getItem('selectedState');
        if (savedState) {
            try {
                const parsedState = JSON.parse(savedState);
                setSelectedState(parsedState);
                const lat = parseFloat(parsedState.latitude || parsedState.lat || 24.4539);
                const lng = parseFloat(parsedState.longitude || parsedState.lng || 54.3773);
                setLatitude(lat);
                setLongitude(lng);
            } catch (error) {
                console.error("Error parsing saved state:", error);
                // Keep default values already set
            }
        }
    }, []);

    useEffect(() => {
        // Try to get user's actual location (non-blocking)
        // Coordinates are already set to defaults, so API calls won't wait
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    setLatitude(position.coords.latitude);
                    setLongitude(position.coords.longitude);
                },
                (error) => {
                    console.error("Error getting location:", error);
                    // Keep default values already set
                },
                {
                    timeout: 5000, // 5 second timeout
                    enableHighAccuracy: false // Faster response
                }
            );
        }
    }, []);

    // Handle location change from country popup
    const handleStateChange = (state) => {
        const lat = parseFloat(state.latitude || state.lat || 24.4539);
        const lng = parseFloat(state.longitude || state.lng || 54.3773);

        console.log("🟢 Location Selected:", state.name, "Lat:", lat, "Lng:", lng);

        setSelectedState(state);
        setLatitude(lat);
        setLongitude(lng);
        setCountrypopup(false);

        localStorage.setItem('selectedState', JSON.stringify(state));
    };
    useEffect(() => {
        filterDataByTab();
    }, [activeTab, offers]);


    useEffect(() => {
        // Coordinates are set immediately with defaults, so this will always run
        // Load primary data first (coupon list for UnlimitedOffers tab) - this will hide loading when done
        fetchCouponList(""); // Initial load without search - this manages loading state
        
        // Load secondary data in parallel (don't wait for these)
        const secondaryPromises = [
            fetchOffers(),
            fetchMasterData(),
            fetchOffertype(),
            fetchCategories()
        ];
        
        // Don't await - let these load in background
        Promise.all(secondaryPromises).catch(error => {
            console.error("Error loading secondary data:", error);
        });
    }, [latitude, longitude, emirate, selectedState]);

    // Debounced search effect - triggers when searchTerm changes
    useEffect(() => {
        // Coordinates are set immediately with defaults, so this will always run
        // Debounce the API call
        const timeoutId = setTimeout(() => {
            fetchCouponList(searchTerm.trim());
        }, 500); // 500ms debounce delay

        return () => clearTimeout(timeoutId);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchTerm]);

    const filterDataByTab = () => {
        if (activeTab === "UnlimitedOffers") {
            // Filter for Unlimited Experience (view_type = 1 or whatever your logic is)
            const filtered = offers.filter(offer => offer.view_type === 1);
            setFilteredData(filtered);
        } else if (activeTab === "Trending This Week") {
            // Filter for Trending (view_type = 3)
            const filtered = offers.filter(offer => offer.view_type === 3);
            setFilteredData(filtered);
        } else if (activeTab === "Limited-Time Deals") {
            // Filter for Limited Deals (view_type = 5)
            const filtered = offers.filter(offer => offer.view_type === 5);
            setFilteredData(filtered);
        } else {
            setFilteredData([]);
        }
    };

    const handleTabClick = (tabName) => {
        setActiveTab(tabName);

        // Update URL parameter
        const urlFriendlyName = Object.keys(tabMapping).find(
            key => tabMapping[key] === tabName
        );
        navigate(`/unlimitedoffers?tab=${urlFriendlyName}`, { replace: true });
    };

    // Get mobile header title based on active tab
    const getMobileHeaderTitle = () => {
        switch (activeTab) {
            case "UnlimitedOffers":
                return "Unlimited Experience";
            case "Trending This Week":
                return "Trending This Week";
            case "Limited-Time Deals":
                return "Limited-Time Deals";
            default:
                return "Unlimited Experience";
        }
    };


    return (
        <div>
            <Navbar />

            {/* Mobile Sidebar Overlay */}
            {menuOpen && (
                <div
                    className="sidebar-overlay"
                    onClick={closeMenu}
                ></div>
            )}

            {/* Mobile Sidebar */}
            <aside className={`mobile-sidebar ${menuOpen ? "open" : ""}`}>
                <div className="sidebar-header">
                    <button
                        className="close-sidebar-btn"
                        onClick={closeMenu}
                        aria-label="Close menu"
                    >
                        <img src={xmark} alt="xmark" className="close-popup" />
                    </button>
                </div>

                <div className="sidebar-menu-content">
                    {/* Navigation Links */}
                    <Link
                        to="/"
                        className="sidebar-menu-item"
                        onClick={closeMenu}
                    >
                        <div className="sidebar-menu-icon">
                            <img src={homeicon} alt="home" />
                        </div>
                        <span>Home</span>
                    </Link>
                    <Link
                        to="/videoposts"
                        className="sidebar-menu-item"
                        onClick={closeMenu}
                    >
                        <div className="sidebar-menu-icon">
                            <img src={videos} alt="videos" />
                        </div>
                        <span>Videos for you</span>
                    </Link>

                    <Link
                        to="/experience"
                        className="sidebar-menu-item"
                        onClick={closeMenu}
                    >
                        <div className="sidebar-menu-icon">
                            <img src={experienceicon} alt="experience" />
                        </div>
                        <span>Experience</span>
                    </Link>

                    <Link
                        to="/business-and-brands"
                        className="sidebar-menu-item"
                        onClick={closeMenu}
                    >
                        <div className="sidebar-menu-icon">
                            <img src={businessicon} alt="business" />
                        </div>
                        <span>Businesses</span>
                    </Link>
                </div>

                {/* App Download Section */}
                <div className="sidebar-download-section">
                    <h4>Download Hayat In App</h4>
                    <div className="sidebar-store-buttons">
                        <a
                            href="https://apps.apple.com/ae/app/hayat-in/id6738689937"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="store-button-link"
                        >
                            <img src={app_store} alt="Download on the App Store" />
                        </a>
                        <a
                            href="https://play.google.com/store/apps/details?id=com.hayatinapp.hayatin"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="store-button-link"
                        >
                            <img src={play_store} alt="Get it on Google Play" />
                        </a>
                    </div>
                </div>

                {/* Register Business Button */}
                <div className="sidebar-register-section">
                    <a href="https://www.hayatinapp.com/vendor/register">
                        <button className="sidebar-register-btn">
                            Register Your Business
                        </button>
                    </a>
                </div>

                {/* Footer Links */}
                <div className="sidebar-footer-links">
                    <div className="sidebar-footer-row">
                        <a href="/about">About Us</a>
                        <Link to="/merchantagreement" className="sidebar-footer-link-arrow" onClick={closeMenu}>
                            <span>Privacy & Terms</span>
                            <img src={downarrow} alt="down arrow" />
                        </Link>
                    </div>
                </div>
            </aside>

            {/* Mobile Header - Only visible on mobile/tablet (320px - 992px) */}
            <div className="mobile-header">
                <img src={leftarrow} alt="back" className="back-arrow" onClick={() => navigate(-1)} />
                <h1 className="mobile-header-title">{getMobileHeaderTitle()}</h1>
            </div>

            {/* Mobile Search Container - Only visible on mobile/tablet (320px - 992px) */}
            <div className="mobile-search-container-unlimitedofferspage">
                <div className="mobile-search-box">
                    <img src={search} alt="search" />
                    <input
                        type="text"
                        placeholder="Search offers..."
                        value={searchTerm}
                        onChange={handleSearchChange}
                    />
                    {searchTerm && (
                        <img
                            src={xmark}
                            alt="clear"
                            className="search-clear-icon"
                            onClick={clearSearch}
                            style={{ width: '10px', height: '10px', cursor: 'pointer' }}
                        />
                    )}
                </div>
                <button className="offer-type-btn" onClick={() => setFilterpopup(true)}>
                    Offer Type
                    <img src={downarrowicon} alt="dropdown" />
                </button>
            </div>

            {/* Mobile Tabs Slider - Only visible on mobile/tablet (320px - 992px) */}
            <div className="mobile-tabs-slider">
                <div className="offer-tabs-mobile">
                    <button
                        className={activeTab === "UnlimitedOffers" ? "active" : ""}
                        onClick={() => handleTabClick("UnlimitedOffers")}
                    >
                        Unlimited Experience
                    </button>

                    <button
                        className={activeTab === "Trending This Week" ? "active" : ""}
                        onClick={() => handleTabClick("Trending This Week")}
                    >
                        Trending This Week
                    </button>

                    <button
                        className={activeTab === "Limited-Time Deals" ? "active" : ""}
                        onClick={() => handleTabClick("Limited-Time Deals")}
                    >
                        Limited-Time Deals
                    </button>
                </div>
            </div>

            <div className="experience-main-layout">
                <aside className="left-section">
                    <div className="searchbox">
                        <img src={search} alt="search" />
                        <input
                            type="text"
                            placeholder="Search..."
                            value={searchTerm}
                            onChange={handleSearchChange}
                        />
                        {searchTerm && (
                            <img
                                src={xmark}
                                alt="clear"
                                className="search-clear-icon"
                                onClick={clearSearch}
                                style={{ width: '10px', height: '10px', cursor: 'pointer' }}
                            />
                        )}
                    </div>
                    <div className="left-menu-content">
                        {/* <div className="img-contentname">
                            <img src={videos} alt="videos" />
                            <p>Videos for you</p>
                        </div> */}
                        <div className="img-contentname" onClick={() => setCountrypopup(true)} >
                            <img src={flagicon} alt="flag" className="flagicon" />
                            <p>{selectedState?.name || emirate?.name || "Abu Dhabi"}</p>
                        </div>
                    </div>
                    <div className="divider-line"></div>
                    <div className="left-bottom-links">
                        {/* <div className="left-bottom1">
                            <a href="/about">About</a>
                            <a href="#BusinessPro">Business Pro</a>
                        </div>
                        <div className="left-bottom1">
                            <a href="#help-center">Help Center</a>
                            <a href="#FAQ">FAQ</a>
                            <a href="#Careers">Careers</a>
                        </div> */}
                        <div className="left-bottom1">
                            <a href="/about">About Us</a>

                            <div className="content-arrow">
                                <Link to="/merchantagreement" className="privacy-link">
                                    <span>Privacy & Terms</span>
                                    <img src={downarrow} alt="down arrow" />
                                </Link>
                            </div>
                             <a href="/downloadpage">Download</a>
                            {/* <div className="content-arrow">
                                <a href="#Languages">Language</a>
                                <img src={downarrow} alt="downarrow" />
                            </div> */}
                        </div>
                    </div>
                </aside>

                <main className="experience-middle-section">
                    <div className="mid-section-head-div">
                        <img src={expbanner} alt="enjoy summer" className="enjoy-summer-img" />
                    </div>

                    <div className="unlimitedoffers-wrapper">
                        <div className="unlimitedoffers-section">
                            {/* Desktop Tabs - Only visible on website (above 992px) */}
                            <div className="offer-tabs desktop-tabs">
                                <button
                                    className={activeTab === "UnlimitedOffers" ? "active" : ""}
                                    onClick={() => handleTabClick("UnlimitedOffers")}
                                >
                                    New Offers
                                </button>

                                <button
                                    className={activeTab === "Trending This Week" ? "active" : ""}
                                    onClick={() => handleTabClick("Trending This Week")}
                                >
                                    Trending This Week
                                </button>

                                <button
                                    className={activeTab === "Limited-Time Deals" ? "active" : ""}
                                    onClick={() => handleTabClick("Limited-Time Deals")}
                                >
                                    Limited-Time Deals
                                </button>

                            </div>
                        </div>

                        <div className="category-list-menu-filter-div">
                            {/* <img src={rightarrow} alt="down arrow icon" className="right-arrow-icon" /> */}

                            <div className="menu-map-filter-div">
                                <img src={menuicon} alt="menu icon" className="menu-icon" />
                                <img src={vertical_line} alt="vertical line" className="vertical-line" />
                                <img src={filtericon} alt="filter icon" className="filter-icon" onClick={() => setFilterpopup(true)} />
                            </div>
                        </div>
                    </div>

                    <div>
                        {/* SHOW SHIMMER LOADER */}
                        {loading && <ShimmerLoader />}

                        {/* Show content ONLY when loading = false */}
                        {!loading && (
                            <>
                                {/* UnlimitedOffers Tab */}
                                {activeTab === "UnlimitedOffers" && (() => {
                                    const displayData = getDisplayData("UnlimitedOffers", categorylist);
                                    return displayData.length > 0 ? (
                                        <div className="offers-grid-container">
                                            {displayData.map((item, index) => renderOfferCard(item, index))}
                                        </div>
                                    ) : (
                                        <div className="nodata-message">
                                            <img src={nodata} alt="no data" className="no-data-img" />
                                            <p className="no-data-p1">No experience found</p>
                                            <p className="no-data-p2">Come back later to explore</p>
                                        </div>
                                    );
                                })()}

                                {/* Trending This Week Tab */}
                                {!loading && activeTab !== "UnlimitedOffers" && getTrendingData().length > 0 &&
                                    offers.find(o => o.title === activeTab && o.title?.toLowerCase().includes("trending")) && (() => {
                                        const trendingData = getTrendingData();
                                        const displayData = getDisplayData(activeTab, trendingData);
                                        return displayData.length > 0 ? (
                                            <div className="offers-grid-container">
                                                {displayData.map((item, index) => renderOfferCard(item, index))}
                                            </div>
                                        ) : (
                                            <div className="nodata-message">
                                                <img src={nodata} alt="no data" className="no-data-img" />
                                                <p className="no-data-p1">No experience found</p>
                                                <p className="no-data-p2">Come back later to explore</p>
                                            </div>
                                        );
                                    })()}

                                {/* Limited-Time Deals Tab */}
                                {!loading && activeTab !== "UnlimitedOffers" && getLimitedTimeData().length > 0 &&
                                    offers.find(o => o.title === activeTab && o.title?.toLowerCase().includes("limited")) && (() => {
                                        const limitedData = getLimitedTimeData();
                                        const displayData = getDisplayData(activeTab, limitedData);
                                        return displayData.length > 0 ? (
                                            <div className="offers-grid-container">
                                                {displayData.map((item, index) => renderOfferCard(item, index))}
                                            </div>
                                        ) : (
                                            <div className="nodata-message">
                                                <img src={nodata} alt="no data" className="no-data-img" />
                                                <p className="no-data-p1">No experience found</p>
                                                <p className="no-data-p2">Come back later to explore</p>
                                            </div>
                                        );
                                    })()}
                            </>
                        )}

                    </div>
                </main>
            </div>

            {/* Country pop up */}
            {countrypopup && (
                <>
                    <div className="custom-overlay" onClick={() => setCountrypopup(false)}></div>
                    <div className="custom-popup">
                        <div className="custom-popup-header">
                            <h4>Choose Your Location</h4>
                            <img src={xmark} alt="close" className="close-popup" onClick={() => setCountrypopup(false)} />
                        </div>

                        <div className="custom-popup-body">
                            <div className="state-grid">
                                {states.filter((state) => Number(state.country_id) === 1)
                                    .map((state, index, arr) => {
                                        const isDisabled = index >= arr.length - 4;
                                        return (
                                            <div
                                                key={state.id}
                                                className={`state-item ${isDisabled ? "disabled" : ""}`}
                                                onClick={() => !isDisabled && handleStateChange(state)}
                                            >
                                                <img
                                                    src={index < 2 ? flagicon : countryicons[index - 2]}
                                                    alt="flag"
                                                    className="flagicon-popup"
                                                />
                                                <p>{state.name}</p>
                                            </div>
                                        );
                                    })}
                            </div>
                        </div>
                    </div>
                </>
            )}


            {filterpopup && (
                <>
                    <div className="overlay" onClick={() => setFilterpopup(false)}></div>
                    <div className="popup-drawer">
                        <div className="popup-header">
                            <h4></h4>
                            <img src={xmark} alt="xmark" className="close-popup" onClick={() => setFilterpopup(false)} />
                        </div>


                        <div className="filter-list">

                            {/* <div className="filter-section">
                                <div className="filter-header" onClick={togglecategoryname}>
                                    <h6 className="filter-title">Categories</h6>
                                    <img
                                        src={downarrowicon}
                                        alt="down arrow"
                                        className={`sub-down-arrow-icon ${showcatgoryname ? "rotate" : ""}`}
                                    />
                                </div>
                                {showcatgoryname && (
                                    <div className="filter-checkbox-list">
                                        {categories.map((cat) => (
                                            <label key={cat.id} className="filter-checkbox-item">
                                                <input
                                                    type="checkbox"
                                                    value={cat.id}
                                                    checked={selectedOfferTypes.includes(cat.id)}
                                                    onChange={(e) => handleCheckboxChange(e, cat.id)}
                                                />
                                                {cat.category_name}
                                            </label>
                                        ))}
                                    </div>
                                )}

                            </div> */}



                            <div className="filter-section">
                                <div className="filter-header" onClick={toggleOfffertype}>
                                    <h6 className="filter-title">Offer Type</h6>
                                    <img src={downarrowicon} alt="down arrow" className={`sub-down-arrow-icon ${openoffertype ? "rotate" : ""}`} />
                                </div>
                                {openoffertype && (
                                    <div className="filter-checkbox-list">
                                        {matchedOfferTypes?.map((off) => (
                                            <label key={off.id} className="filter-checkbox-item">
                                                <input
                                                    type="checkbox"
                                                    value={off.id}
                                                    checked={selectedOfferTypes.includes(off.id)}
                                                    onChange={(e) => handleCheckboxChange(e, off.id)}
                                                />
                                                {off.discount_type}
                                            </label>
                                        ))}
                                    </div>
                                )}
                            </div>

                            <div className="filter-buttons-bottom">
                                <button className="clear-btn" onClick={clearAllFilters}>Clear All</button>
                                <button className="show-btn" onClick={handleShowResult}>Show Result</button>
                            </div>
                        </div>

                    </div>
                </>
            )}


        </div>
    )
}


export default UnlimitedOffers